import { TripBookingReminder } from '../../lib/types/models/trip-booking/trip-booking-reminder'
import { TripBookingReminderInput } from '../../lib/types/models/trip-booking/trip-booking-reminder-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripBookingReminder(
  input: TripBookingReminderInput & { tripBookingId: number }
) {
  const { tripBookingId, ...data } = input
  return restApiClient
    .url(constructApiUrl(API['trip-bookings'].createReminder.url, { id: tripBookingId }))
    .post<TripBookingReminder, TripBookingReminderInput>(data)
}
